// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { parseEntityPresentation, sortByPresentationOrder, } from "@sequentech/ui-core";
import { translatedLabel } from "./resultLabels";
var sameId = function (left, right) {
    return left !== null &&
        left !== undefined &&
        right !== null &&
        right !== undefined &&
        String(left) === String(right);
};
var unique = function (values) {
    var seen = new Set();
    return values.reduce(function (output, value) {
        if (value === null || value === undefined)
            return output;
        var id = String(value);
        if (!seen.has(id)) {
            seen.add(id);
            output.push(id);
        }
        return output;
    }, []);
};
var findRow = function (rows, id) { return rows.find(function (row) { return sameId(row.id, id); }); };
export var getElectionEventPresentation = function (manifest, dataset) {
    var _a;
    return parseEntityPresentation((_a = dataset.election_event.find(function (row) { return sameId(row.id, manifest.election_event_id); })) === null || _a === void 0 ? void 0 : _a.presentation);
};
export var orderResultElectionIds = function (manifest, dataset, locale) {
    var _a;
    var ids = unique(__spreadArray(__spreadArray([], manifest.election_ids, true), manifest.contests.map(function (contest) { return contest.election_id; }), true));
    var order = (_a = getElectionEventPresentation(manifest, dataset)) === null || _a === void 0 ? void 0 : _a.elections_order;
    return sortByPresentationOrder(ids, order, {
        getLabel: function (id) { return translatedLabel(findRow(dataset.election, id), locale, id); },
        getPresentation: function (id) { var _a; return (_a = findRow(dataset.election, id)) === null || _a === void 0 ? void 0 : _a.presentation; },
    });
};
export var orderResultContestIds = function (manifest, dataset, electionId, locale) {
    var _a;
    var ids = unique(manifest.contests
        .filter(function (contest) { return sameId(contest.election_id, electionId); })
        .map(function (contest) { return contest.contest_id; }));
    var election = findRow(dataset.election, electionId);
    var order = (_a = parseEntityPresentation(election === null || election === void 0 ? void 0 : election.presentation)) === null || _a === void 0 ? void 0 : _a.contests_order;
    return sortByPresentationOrder(ids, order, {
        getLabel: function (id) { return translatedLabel(findRow(dataset.contest, id), locale, id); },
        getPresentation: function (id) { var _a; return (_a = findRow(dataset.contest, id)) === null || _a === void 0 ? void 0 : _a.presentation; },
    });
};
export var orderResultCandidates = function (dataset, contestId, locale) {
    var _a;
    var contest = findRow(dataset.contest, contestId);
    var order = (_a = parseEntityPresentation(contest === null || contest === void 0 ? void 0 : contest.presentation)) === null || _a === void 0 ? void 0 : _a.candidates_order;
    var candidates = dataset.candidate.filter(function (candidate) {
        return sameId(candidate.contest_id, contestId);
    });
    return sortByPresentationOrder(candidates, order, {
        getLabel: function (candidate) { return translatedLabel(candidate, locale); },
        getPresentation: function (candidate) { return candidate.presentation; },
    });
};
export var orderElectionResultRows = function (rows, manifest, dataset, locale) {
    var _a;
    var order = (_a = getElectionEventPresentation(manifest, dataset)) === null || _a === void 0 ? void 0 : _a.elections_order;
    var snapshotOrder = new Map(unique(__spreadArray(__spreadArray([], manifest.election_ids, true), manifest.contests.map(function (contest) { return contest.election_id; }), true)).map(function (id, index) { return [id, index]; }));
    var snapshotPosition = function (electionId) {
        var _a;
        return electionId === null || electionId === undefined
            ? Number.MAX_SAFE_INTEGER
            : ((_a = snapshotOrder.get(String(electionId))) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER);
    };
    var snapshotRows = __spreadArray([], rows, true).sort(function (left, right) {
        return snapshotPosition(left.election_id) - snapshotPosition(right.election_id);
    });
    return sortByPresentationOrder(snapshotRows, order, {
        getLabel: function (row) {
            return translatedLabel(findRow(dataset.election, row.election_id), locale, String(row.id));
        },
        getPresentation: function (row) { var _a; return (_a = findRow(dataset.election, row.election_id)) === null || _a === void 0 ? void 0 : _a.presentation; },
    });
};
